module.exports = __webpack_public_path__ + "img/student-resource.d16f375a.svg";